import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useDimensoesPrincipaisSection } from "./use-dimensoes-principais-section";
import { DimensoesPrincipaisSectionView } from "./view-dimensoes-principais-section";

export function DimensoesPrincipaisSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useDimensoesPrincipaisSection(props);

  return <DimensoesPrincipaisSectionView {...vm} />;
}

export type * from "./types-dimensoes-principais-section";
